/* unplugin-vue-components disabled */import { render } from "./base-option-dialog.vue?vue&type=template&id=e48f7b6a"
import script from "./base-option-dialog.vue?vue&type=script&lang=js"
export * from "./base-option-dialog.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/amoeba-logistics-information-system-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__